import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Language } from '@wellesley/openapi'
import { platformSettingsSlice } from '../../slices/platformSettingsSlice'
import { useProfileSettings } from '../../profile/hooks/useProfileSettings'
import { platformSettingsKeysMap } from '../../keys'

const useTranslationConfigs = () => {
  const platformSettings = useSelector(
    platformSettingsSlice.selectors.selectSettings,
  )

  const { settings, isLoading } = useProfileSettings()
  const { preferredLanguage, excludedLanguages } =
    settings?.user?.translation || {}

  const isEnabled =
    platformSettings?.[platformSettingsKeysMap.translation]?.enabled || false
  const isSettingsReady = !isLoading && !!settings

  const checkIfTranslatable = useCallback(
    (entityLang?: Language | null) => {
      if (!isEnabled || !isSettingsReady) return false

      const skipLanguages = [
        ...(excludedLanguages || []),
        preferredLanguage,
      ].map((lang) => lang?.toLowerCase())

      return !!entityLang && !skipLanguages.includes(entityLang.toLowerCase())
    },
    [isEnabled, isSettingsReady, preferredLanguage, excludedLanguages],
  )

  return {
    isEnabled,
    isSettingsReady,
    preferredLanguage,
    checkIfTranslatable,
  }
}

export default useTranslationConfigs
